import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { sendToVercelAnalytics } from './vitals';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { theme } from './theme';
import { PedidoProvider } from './contexts/PedidoContext';
import { BrandingProvider } from './branding/BrandingContext';
import { AuthSessionProvider } from './contexts/AuthSessionContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <PedidoProvider>
      <BrandingProvider>
        <AuthSessionProvider>
          <App />
        </AuthSessionProvider>
      </BrandingProvider>
    </PedidoProvider>
  </ThemeProvider>
);

reportWebVitals(sendToVercelAnalytics);
